import React from 'react';
import { Flex, useDirection } from '@edreamsodigeo/prisma-design-system';
import CarrierImage from './CarrierImage';

const images: Record<string, string> = {
  MA: '/images/mobile/airline_logos/MA.png',
  MIX: '/images/onefront/airlines/smVIN2.gif',
};

interface CarrierLogoProps {
  id: string;
  name: string;
}

const CarrierLogo: React.FC<CarrierLogoProps> = ({ id, name }) => {
  const imgSrc = images[id] || `/images/onefront/airlines/sm${id}.gif`;
  const isRtl = useDirection();
  return (
    <Flex pr={isRtl ? null : '2x_small'} pl={isRtl ? '2x_small' : null}>
      <CarrierImage src={imgSrc} alt={name} />
    </Flex>
  );
};

export default CarrierLogo;
